import { render, staticRenderFns } from "./nbmeter.vue?vue&type=template&id=2bbc6990&"
import script from "./nbmeter.vue?vue&type=script&lang=js&"
export * from "./nbmeter.vue?vue&type=script&lang=js&"
import style0 from "./nbmeter.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports